import { useSelector } from 'react-redux'
import { selectDevicesMapStyles } from '@/features/domain/ui'

export const useDevicesMapStyle = () => {
  const { mode, custom } = useSelector(selectDevicesMapStyles)

  if (Object.keys(custom).length > 0) return

  return mode
}
